import initHttpClient from './httpClient/httpClient.esm.js';
import { SearchAPI } from './sources/search.esm.js';
import { GraphAPI } from './sources/graph.esm.js';
import { PartnersAPI } from './sources/partners.esm.js';
import { AgreementAPI } from './sources/agreement.esm.js';
import { AzureManagementAPI } from './sources/azureManagement.esm.js';
import { LeadsAPI } from './sources/leads.esm.js';
import { AppSourceAPI } from './sources/appsource.esm.js';

function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var RestClient = /*#__PURE__*/ function() {
    function RestClient(authCB) {
        _class_call_check(this, RestClient);
        _define_property(this, "_httpClient", void 0);
        _define_property(this, "agreementAPI", void 0);
        _define_property(this, "leadsAPI", void 0);
        _define_property(this, "searchAPI", void 0);
        _define_property(this, "partnersAPI", void 0);
        _define_property(this, "appsourceAPI", void 0);
        _define_property(this, "graphAPI", void 0);
        _define_property(this, "azureManagementAPI", void 0);
        this._httpClient = initHttpClient(authCB);
    }
    _create_class(RestClient, null, [
        {
            key: "getInstance",
            value: function getInstance() {
                if (!RestClient.instance) {
                    throw new Error('please use init() before using the rest client');
                }
                return RestClient.instance;
            }
        },
        {
            key: "init",
            value: function init(cb) {
                RestClient.instance = new RestClient(cb);
            }
        },
        {
            key: "Agreement",
            get: function get() {
                var instance = RestClient.getInstance();
                if (!instance.agreementAPI) {
                    instance.agreementAPI = new AgreementAPI(instance._httpClient);
                }
                return instance.agreementAPI;
            }
        },
        {
            key: "Leads",
            get: function get() {
                var instance = RestClient.getInstance();
                if (!instance.leadsAPI) {
                    instance.leadsAPI = new LeadsAPI(instance._httpClient);
                }
                return instance.leadsAPI;
            }
        },
        {
            key: "Search",
            get: function get() {
                var instance = RestClient.getInstance();
                if (!instance.searchAPI) {
                    instance.searchAPI = new SearchAPI(instance._httpClient);
                }
                return instance.searchAPI;
            }
        },
        {
            key: "Partners",
            get: function get() {
                var instance = RestClient.getInstance();
                if (!instance.partnersAPI) {
                    instance.partnersAPI = new PartnersAPI(instance._httpClient);
                }
                return instance.partnersAPI;
            }
        },
        {
            key: "AppSource",
            get: function get() {
                var instance = RestClient.getInstance();
                if (!instance.appsourceAPI) {
                    instance.appsourceAPI = new AppSourceAPI(instance._httpClient);
                }
                return instance.appsourceAPI;
            }
        },
        {
            key: "Graph",
            get: function get() {
                var instance = RestClient.getInstance();
                if (!instance.graphAPI) {
                    instance.graphAPI = new GraphAPI(instance._httpClient);
                }
                return instance.graphAPI;
            }
        },
        {
            key: "AzureManagement",
            get: function get() {
                var instance = RestClient.getInstance();
                if (!instance.azureManagementAPI) {
                    instance.azureManagementAPI = new AzureManagementAPI(instance._httpClient);
                }
                return instance.azureManagementAPI;
            }
        }
    ]);
    return RestClient;
}();
_define_property(RestClient, "instance", void 0);

export { RestClient as default };
